export default "__VITE_ASSET__CByjuz5A__"